"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_EMAIL = exports.RECEIVE_RECOMMENDATIONS_RESULTS = exports.RECEIVE_PROGRAMS_RESULTS = exports.RECEIVE_EMAIL_RESULTS = exports.RECEIVE_EMAIL_ERROR = void 0;
var RECEIVE_RECOMMENDATIONS_RESULTS = 'RECEIVE_RECOMMENDATIONS_RESULTS';
exports.RECEIVE_RECOMMENDATIONS_RESULTS = RECEIVE_RECOMMENDATIONS_RESULTS;
var RECEIVE_PROGRAMS_RESULTS = 'RECEIVE_PROGRAMS_RESULTS';
exports.RECEIVE_PROGRAMS_RESULTS = RECEIVE_PROGRAMS_RESULTS;
var SEND_EMAIL = 'SEND_EMAIL';
exports.SEND_EMAIL = SEND_EMAIL;
var RECEIVE_EMAIL_RESULTS = 'RECEIVE_EMAIL_RESULTS';
exports.RECEIVE_EMAIL_RESULTS = RECEIVE_EMAIL_RESULTS;
var RECEIVE_EMAIL_ERROR = 'RECEIVE_EMAIL_ERROR';
exports.RECEIVE_EMAIL_ERROR = RECEIVE_EMAIL_ERROR;